import { useDebouncedCallback } from '@mantine/hooks'
import { useCallback } from 'react'

export const useDebouncedAsyncValidation = <T>(validateFn: (value: T) => Promise<boolean>, delay: number) => {
  const debouncedValidate = useDebouncedCallback(async (value: T, resolve: (result: boolean) => void) => {
    const result = await validateFn(value)
    resolve(result)
  }, delay)

  return useCallback(
    (value: T): Promise<boolean> => {
      return new Promise((resolve) => {
        debouncedValidate(value, resolve)
      })
    },
    [debouncedValidate]
  )
}
